import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { Button, Table, Input, Alert, Progress } from 'reactstrap'
import { getTenant, uploadFile, configValue, removeFileNamePrefix } from '../../utils'
import { CONFIG_KEYS } from '../../constants'
import FormHeading from './FormHeading'

export function FileUploadForm({ setFileName, reportTitle, reportMessage }) {
  console.log('FileUploadForm rendered')

  const initialFileInfo = {
    serverFileName: null,
    serverUrl: null,
    localFileName: null,
    blobUrl: null,
    file: ''
  } 

  const [fileInfo, setFileInfo] = useState(initialFileInfo)
  const [redirectHome, setRedirectHome] = useState(false)
  const [fileUploadError, setFileUploadError] = useState()
  const [uploadProgress, setUploadProgress] = useState()

  function handleFileChange(event) {
    console.log('*********************************** FileUploadForm.handleFileChange', event.target.files)
    if (event.target.files && event.target.files.length > 0) {
      let maxFileSize = configValue(CONFIG_KEYS.maxFileSize.key) ? configValue(CONFIG_KEYS.maxFileSize.key) : CONFIG_KEYS.maxFileSize.defaultValue
      maxFileSize = parseInt(maxFileSize) * 1024 * 1024
      console.log(`Max File Size: ${maxFileSize} File Size: ${event.target.files[0].size}`)
    }
  
    let localFileName = event.target.value
    localFileName = removeFileNamePrefix(localFileName, '\\')
    let blobUrl = null
    if (event.target.files && event.target.files.length > 0) {
      blobUrl = URL.createObjectURL(event.target.files[0])
    }
    const newFileInfo = {
      serverFileName: null,
      serverUrl: null,
      localFileName: localFileName,
      blobUrl: blobUrl,
      file: event.target.files[0]
    }
    console.log('utils.handleFileChange: ', newFileInfo)
    setFileInfo(newFileInfo)
  }

  function uploadCallback(e, fileInfo) {
    console.log('------------------------------------------------ uploadCallback: ', e, fileInfo)

    if (e.type === 'load' && e.target.status === 201) {
      const newFileName = JSON.parse(e.target.response).newFileName
      setFileName(newFileName)
    }
    if ((e.type === 'load' && e.target.status !== 201) || e.type === 'error') {
      let errorText = e.target.responseText ? e.target.responseText : 'check browser console for error description.'
      setFileUploadError(errorText)
    }
    if (e.type === 'progress' && e.lengthComputable) {
      const percentage = Math.round(e.loaded / e.total * 100)
      console.log(percentage)
      setUploadProgress(percentage)
    }
  }

  function submitFile(e) {
    console.log('FileUploadForm.submitFile', fileInfo)
    e.preventDefault()
    if (!fileInfo.file) {
      setFileUploadError('A file must be selected.')
      return false
    }
    const tenant = getTenant()
    const url = `${process.env.REACT_APP_SERVER}/upload/${tenant}`
    const newFileName = `FP${parseInt(Math.floor(Math.random() * 1000000000))}/${fileInfo.file.name}`
    fileInfo.newFileName = newFileName
    console.log('fileInfo: ', fileInfo)
    uploadFile(url, fileInfo, uploadCallback)
  }
 
  if (redirectHome) {
    return <Navigate to='/home' />
  } else {
    let infoComponent = ''
    if (fileUploadError) {
      infoComponent = <tr><td><Alert color="danger" style={{ marginBottom: '0'}}>{fileUploadError}</Alert></td></tr>
    } else if (uploadProgress) {
      infoComponent = <tr><td><Progress animated value={uploadProgress} style={{ minWidth: '272px'}}>Uploading file...</Progress></td></tr>
    }

    let title = reportTitle ? reportTitle : 'Select a File'
    let message = reportMessage ? <tr><td>{reportMessage}</td></tr> : ''
    return (
      <div className="custom-scroll timekeeper-table">
        <form className="form" onSubmit={submitFile}>
          <div>
            <Table bordered>
              <FormHeading headingText={title} />
              <tbody>
                {infoComponent}
                {message}
                <tr>
                  <td>
                    <Input type='file' name='file' id='file' onChange={handleFileChange} />
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className='timekeeper-table'>
            <Button className='button' color="primary">Ok</Button>
            <Button className='button' onClick={() => setRedirectHome(true)}>Cancel</Button>
          </div>
        </form>
      </div>
    )
  }
}